export const videoConfig = {
  allowFullscreen: false,
  aspectratio: '9:16',
  autoPause: {
    viewability: false
  },
  autostart: true,
  controls: true,
  displayTitle: false,
  mute: false,
  nextUpDisplay: false,
  pipIcon: 'disabled',
  primary: 'html5',
  repeat: true,
  responsive: true,
  showUIWhen: 'onContent',
  stretching: 'fill',
  timeSlider: {
    showKnob: false,
    legacy: true
  },
  width: '100%'
};
